import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.scss']
})
export class MultiselectDropdownComponent implements OnChanges, OnDestroy {
@ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  @ViewChild('dropdownPanel')     dropdownPanel!: ElementRef;

  showDropDown = false;

  @Input() list: any[] = [];
  @Input() listLabel: string = '';
  @Input() required: boolean = false;
  @Input() drowDownColtwo: boolean = false;
  @Input() checkedList: any[] = [];
  @Output() inputValueEmit = new EventEmitter<any>();
  @Input() customClass: any = '';
  @Input() dropdownColOne: boolean = false;
  @Input() isInputDisabled = false;
  @Input() disabled: boolean = false;

  filteredList: any[] = [];

  /** Positioning state */
  openUpward = false;
  private scrollResizeCleanup: (() => void)[] = [];

  constructor(private eRef: ElementRef) {}

  // ─── Outside-click closes the dropdown ───────────────────────────────────
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (this.dropdownContainer && !this.dropdownContainer.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['list'] && this.list) {
      this.checkedList  = this.list.filter(a => a.isActive).map(b => b.name);
      this.filteredList = [...this.list];
    }
  }

  // ─── Toggle ──────────────────────────────────────────────────────────────
  toggleDropdown(): void {
    if (this.disabled) return;
    this.showDropDown ? this.closeDropdown() : this.openDropdown();
  }

  openDropdown(): void {
    this.showDropDown = true;

    // Position AFTER Angular renders the panel (*ngIf just became true)
    requestAnimationFrame(() => this.updatePosition());

    const onScrollResize = () => this.updatePosition();
    window.addEventListener('scroll', onScrollResize, true);
    window.addEventListener('resize', onScrollResize);

    this.scrollResizeCleanup = [
      () => window.removeEventListener('scroll', onScrollResize, true),
      () => window.removeEventListener('resize', onScrollResize)
    ];
  }

  closeDropdown(): void {
    this.showDropDown = false;
    this.scrollResizeCleanup.forEach(fn => fn());
    this.scrollResizeCleanup = [];
  }

  // ─── Core positioning logic ───────────────────────────────────────────────
private updatePosition(): void {
  const host  = this.dropdownContainer?.nativeElement as HTMLElement;
  const panel = this.dropdownPanel?.nativeElement as HTMLElement;
  if (!host || !panel) return;

  const hostRect       = host.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const spaceBelow     = viewportHeight - hostRect.bottom;
  const spaceAbove     = hostRect.top;
  const maxPanelHeight = 242;

  this.openUpward = spaceBelow < maxPanelHeight && spaceAbove > spaceBelow;

  const availableHeight = this.openUpward
    ? Math.min(spaceAbove, maxPanelHeight)
    : Math.min(spaceBelow, maxPanelHeight);

  // Measure real content height
  panel.style.maxHeight = `${availableHeight}px`;
  const panelHeight = Math.min(panel.scrollHeight, availableHeight);

  const topPos = this.openUpward
    ? hostRect.top - panelHeight   // anchor to top of host, grow upward
    : hostRect.bottom;             // anchor to bottom of host, grow downward

  // fixed — escapes ALL overflow:hidden ancestors
  panel.style.cssText =
    `position: fixed !important;` +
    `width: ${hostRect.width}px !important;` +
    `left: ${hostRect.left}px !important;` +
    `top: ${topPos}px !important;` +
    `bottom: unset !important;` +
    `max-height: ${availableHeight}px !important;` +
    `z-index: 99999 !important;` +
    `overflow-y: auto !important;` +
    `display: block !important;` +
    `visibility: visible !important;` +
    `opacity: 1 !important;`;
}

  // ─── Item interaction ─────────────────────────────────────────────────────
  toggle(item: any): void {
    item.isActive = !item.isActive;
    this.checkedList = this.list.filter(a => a.isActive).map(b => b.name);
    this.inputValueEmit.emit(item);
  }

  clearSelectedData(): void {
    this.list?.forEach(item => item.isActive = false);
    this.checkedList = [];
    this.inputValueEmit.emit('');
    this.closeDropdown();
  }

  ngOnDestroy(): void {
    this.closeDropdown();
  }
}
